<template>
    <div :class="['address-com', 'bold', 'f26']">
      <div class="info">
        <div class="user">{{model.contacts}} {{model.mobile}} <img src="/images/public/defult_icon.png" alt="" class='defult_img' v-if='selected'/></div>
        <div class="addr">{{model.province}} {{model.city}} {{model.district}} {{model.address}}</div>
        
      </div>
      <div class="edit" @click="toEdit">
        <i></i>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'addr-com',
    props: {
      selected: {
        type: Boolean
      },
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      },
      ins : {
        type : String,
        default : 'nobag'
      }
    },
    data () {
      return { }
    },
    methods: {
      toEdit(){
        if(this.ins == 'bag'){
          this.$emit('toEditAdr',this.model.id)
          return;
        }
        this.$router.push({ name: 'addressEdit',query:{aid:this.model.id,ins:this.ins}});
      }
    }
  }
</script>

<style scoped lang="scss">
  .defult_img{
    width: 64px;
    position: relative;
    top:4px;
    margin-left: 10px;
  }
  .address-com{
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px dashed #eee;
    padding: 14px 0;
    padding-top: 0;
    padding-bottom: 32px;
    margin-left:18px;
    .info{
      width: 500px;
      .addr{
        width: 500px;
        line-height: 36px;
        font-size:26px;
        font-weight:400;  
        margin-top: 16px;
      }
      .user{
        font-size:28px;
        font-weight:500;  
      }
    }
    .edit{
      display: flex;
      align-items: center;
      i{
        display: block;
        width: 34px;
        height: 38px;
        background: url("/images/public/edit-icon.png") no-repeat center;
        background-size: cover;
      }
    }
  }
</style>
